import {chainProtocolRegistry,protocolForNetwork,type Network} from './chain-protocol-registry.js';

export type PaymentAsset={id:string;network:Network;asset:string;decimals:number;contract:`0x${string}`|null};
// Issuer contract: https://developers.circle.com/stablecoins/usdc-contract-addresses
// The wallet also reads decimals() and contract code from its verified chain before admission.
const tokens:PaymentAsset[]=[{id:'ethereum-mainnet:usdc',network:'ethereum-mainnet',asset:'USDC',decimals:6,contract:'0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'}];
export const PAYMENT_ASSETS:readonly PaymentAsset[]=[
  ...(Object.keys(chainProtocolRegistry) as Network[]).map(network=>{
    const native=protocolForNetwork(network).nativeAsset;
    return {id:network,network,asset:native.code,decimals:native.decimals,contract:null};
  }),...tokens,
];
export function paymentAsset(id:string):PaymentAsset{
  const found=PAYMENT_ASSETS.find(item=>item.id===id);
  if(!found)throw new Error(`Unsupported payment asset: ${id}`);
  return found;
}

export function observedPaymentAsset(transfer:{network:string;asset:string;decimals:number}):PaymentAsset{
  const found=PAYMENT_ASSETS.find(asset=>asset.network===transfer.network&&asset.asset===transfer.asset&&asset.decimals===transfer.decimals);
  if(!found)throw new Error(`The observed asset has no approved registry entry: ${transfer.asset} on ${transfer.network}.`);
  return found;
}
